import React, { useState } from 'react';
import './BusinessListingForm.css';
import Stepper from './Stepper';
import StepBasicInfo from './StepBasicInfo';
import StepContactLocation from './StepContactLocation';
import StepServicesHours from './StepServicesHours';
import StepMediaSocial from './StepMediaSocial';
import NavigationButtons from './NavigationButtons';

const BusinessListingForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    // Step 1: Basic Info
    businessName: '',
    category: '',
    subcategory: '',
    description: '',
    
    // Step 2: Contact & Location
    city: '',
    area: '',
    fullAddress: '',
    contactNumber: '',
    whatsappNumber: '+919510682249',
    email: '',
    website: '',
    
    // Step 3: Services & Hours
    services: [],
    pricing: '',
    operatingDays: [],
    openingTime: '',
    closingTime: '',
    
    // Step 4: Media & Social
    logo: null,
    images: [],
    facebook: '',
    instagram: '',
    twitter: ''
  });

  const handleStepDataChange = (stepData) => {
    setFormData(prevData => ({ ...prevData, ...stepData }));
  };

  const handleNext = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    console.log('Form submitted with data:', formData);
    
    // Format business details for WhatsApp
    const businessDetails = `
📋 *Business Listing Details*

🏢 *Business Name:* ${formData.businessName || 'Not provided'}
🏷️ *Category:* ${formData.category || 'Not provided'}
📝 *Subcategory:* ${formData.subcategory || 'Not provided'}

📍 *Location Details:*
🏙️ *City:* ${formData.city || 'Not provided'}
📍 *Area:* ${formData.area || 'Not provided'}
📬 *Full Address:* ${formData.fullAddress || 'Not provided'}

📞 *Contact Information:*
📱 *Contact:* ${formData.contactNumber || 'Not provided'}
💬 *WhatsApp:* ${formData.whatsappNumber || 'Not provided'}
📧 *Email:* ${formData.email || 'Not provided'}
🌐 *Website:* ${formData.website || 'Not provided'}

⏰ *Business Hours:*
📅 *Operating Days:* ${formData.operatingDays?.join(', ') || 'Not specified'}
🕐 *Opening:* ${formData.openingTime || 'Not specified'}
🕑 *Closing:* ${formData.closingTime || 'Not specified'}

💼 *Services:*
${formData.services?.map(service => `• ${service}`).join('\n') || 'No services specified'}

💰 *Pricing:*
${formData.pricing || 'No pricing information provided'}

📱 *Social Media:*
📘 *Facebook:* ${formData.facebook || 'Not provided'}
📷 *Instagram:* ${formData.instagram || 'Not provided'}
🐦 *Twitter:* ${formData.twitter || 'Not provided'}

---
*Submitted via Business Listing Platform*
    `.trim();

    // WhatsApp sharing functionality
    const whatsappNumber = '9510682249'; // The number you specified
    const whatsappMessage = encodeURIComponent(businessDetails);
    const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/\D/g, '')}?text=${whatsappMessage}`;
    
    // Open WhatsApp in new tab
    window.open(whatsappUrl, '_blank');
    
    // Also show success message
    alert('Business listing submitted! Opening WhatsApp to share details...');
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <StepBasicInfo
            data={formData}
            onChange={handleStepDataChange}
          />
        );
      case 2:
        return (
          <StepContactLocation
            data={formData}
            onChange={handleStepDataChange}
          />
        );
      case 3:
        return (
          <StepServicesHours
            data={formData}
            onChange={handleStepDataChange}
          />
        );
      case 4:
        return (
          <StepMediaSocial
            data={formData}
            onChange={handleStepDataChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="business-listing-form">
      <div className="form-container">
        <div className="form-header">
          <h1>List Your Business</h1>
          <p>Reach thousands of potential customers. It&apos;s free!</p>
        </div>

        <Stepper currentStep={currentStep} />

        <div className="form-content">
          {renderCurrentStep()}
        </div>

        <NavigationButtons
          currentStep={currentStep}
          onPrevious={handlePrevious}
          onNext={handleNext}
          onSubmit={handleSubmit}
        />
        
        <div className="form-features">
          <div className="feature-item">
            <span className="check-icon">✓</span>
            <span>Free Listing</span>
          </div>
          <div className="feature-item">
            <span className="check-icon">✓</span>
            <span>Verified Badge Available</span>
          </div>
          <div className="feature-item">
            <span className="check-icon">✓</span>
            <span>Reach 50,000+ Customers</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessListingForm;
